module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAoElEQVQ4T82SsQ3CMAAE70sGYQIKWgZAKRENYgA2oAkMQEdHRwesQs06j4IcFIIdLEVIce0/694veh71zDMQgO0dcJX0yFGyPQHmkvYvBdsz4AgsfkFC+B7u3t4d5EDa4erxjxK7ILHwF6ChcwBWtU4qHAU0ICWwAUZA5byUdGmXnNyB7SmwBQpgLekc+6HOIYVOxpJOqe8dyBJz1vc3hSem8UAR2YkPMwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/down.png
// module id = WIY8
// module chunks = 1